export function newNotice(notice) {
  return {
    type: "NEW_NOTICE",
    data: notice
  };
}

export function editNotice(notice) {
  return {
    type: "EDIT_NOTICE",
    data: notice
  };
}
export function hideModal() {
  return {
    type: "HIDE_NOTICE_MODAL"
  };
}



// WEBPACK FOOTER //
// ./src/actions/notices.js